<template>
  <div class="content-box">
    <Title />
    <div class="nav-wrapper">
      <div class="vertical-nav">
        <div
          v-for="(primaryItem, primaryIndex) of navData"
          :key="'primary-' + primaryIndex"
          class="nav-row"
        >
          <div
            class="primary-item"
            :class="{ active: isPrimaryActive(primaryIndex) }"
            @click="handlePrimarySelect(primaryIndex)"
          >
            {{ primaryItem.label }}
          </div>
          <div class="secondary-items">
            <span
              v-for="(secondaryItem, secondaryIndex) of primaryItem.children"
              :key="'secondary-' + primaryIndex + '-' + secondaryIndex"
              class="secondary-item"
              :class="{ active: isSecondaryActive(primaryIndex, secondaryIndex) }"
              @click.stop="handleSecondarySelect(primaryIndex, secondaryIndex)"
            >
              {{ secondaryItem.label }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in allNavItems"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "complainList",
  data() {
    return {
      activePrimaryIndex: 0,
      activeSecondaryIndex: 0,
      name: "投诉（车）",
      navData: [
        {
          label: "投诉",
          children: [
            {
              value: "投诉 车",
              label: "投诉（车）",
            },
            {
              value: "投诉 特斯拉",
              label: "特斯拉投诉",
            },
            {
              value: "投诉 比亚迪",
              label: "比亚迪投诉",
            },
            {
              value: "投诉 蔚来",
              label: "蔚来投诉",
            },
            {
              value: "投诉 小鹏",
              label: "小鹏投诉",
            },
            {
              value: "投诉 理想",
              label: "理想投诉",
            },
            {
              value: "投诉 瓜子二手车",
              label: "瓜子二手车投诉",
            },
            {
              value: "投诉 途虎",
              label: "途虎投诉",
            },
          ],
        },
        {
          label: "曝光台",
          children: [
            {
              value: "曝光 车",
              label: "曝光台",
            },
            {
              value: "曝光 特斯拉",
              label: "特斯拉曝光",
            },
            {
              value: "曝光 比亚迪",
              label: "比亚迪曝光",
            },
            {
              value: "曝光 蔚来",
              label: "蔚来曝光",
            },
          ],
        },
      ],
      params: {
        json: 0,
        filter: ["研报", "分析", "（PPT）", "（全文）"],
      },
    };
  },
  computed: {
    allNavItems() {
      return this.navData.flatMap((item) => item.children);
    },
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", "投诉 车");
    this.$store.dispatch("getText");
  },
  methods: {
    isPrimaryActive(primaryIndex) {
      return this.activePrimaryIndex === primaryIndex && this.activeSecondaryIndex === 0;
    },
    isSecondaryActive(primaryIndex, secondaryIndex) {
      return this.activePrimaryIndex === primaryIndex && this.activeSecondaryIndex === secondaryIndex;
    },
    handlePrimarySelect(primaryIndex) {
      this.activePrimaryIndex = primaryIndex;
      this.activeSecondaryIndex = 0;
      const item = this.navData[primaryIndex]?.children[0];
      const searchKey = item?.keyword || item?.value || "投诉 车";
      this.name = item?.label || "投诉（车）";
      this.$store.commit("changeKeys", searchKey);
      this.$store.dispatch("getText");
    },
    handleSecondarySelect(primaryIndex, secondaryIndex) {
      this.activePrimaryIndex = primaryIndex;
      this.activeSecondaryIndex = secondaryIndex;
      const item = this.navData[primaryIndex]?.children[secondaryIndex];
      const searchKey = item?.keyword || item?.value;
      this.name = item?.label || "";
      this.$store.commit("changeKeys", searchKey);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.name = this.allNavItems.find((item) => item.value === value)?.label || value;
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.nav-wrapper {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border-bottom: 2px solid #e74c3c;
}
.vertical-nav {
  padding: 8px 0;
}
.nav-row {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
}
.nav-row:last-child {
  border-bottom: none;
}
.primary-item {
  flex-shrink: 0;
  min-width: 80px;
  padding: 6px 12px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-align: center;
}
.primary-item:hover {
  color: #e74c3c;
  background-color: rgba(231, 76, 60, 0.1);
}
.primary-item.active {
  color: #fff;
  background-color: #e74c3c;
}
.secondary-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 16px;
}
.secondary-item {
  padding: 4px 12px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.8);
}
.secondary-item:hover {
  color: #e74c3c;
  background-color: rgba(231, 76, 60, 0.1);
}
.secondary-item.active {
  color: #fff;
  background-color: #e74c3c;
}
</style>